/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_Add_EventInputs */



/**
* | output |
* | --- |
* | "Add event" |
*
* @param {League_Add_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_add_event = /** @type {((inputs?: League_Add_EventInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Add_EventInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouter un événement")
	if (locale === "es") return /** @type {LocalizedString} */ ("Añadir evento")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Adicionar evento")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiungi evento")
	return /** @type {LocalizedString} */ ("Add event")
});